const Clients = () => import("./Clients.vue");
import Layout from "../../Internal/Layout.vue";

const ClientsRoutes = {
  component: Layout,
  children: [
    {
      path: "/clients",
      name: "Clients",
      component: Clients,
      meta: {
        requiresMaster: true,
        requiresAuth: true,
        requiresAdmin: true,
        requiresMarketing: true,
      },
    },
  ],
};

export default ClientsRoutes;
